import { render, staticRenderFns } from "./EditarItemDialogComponent.vue?vue&type=template&id=1d654aac"
import script from "./EditarItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarItemDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports